import React from 'react';
import { StripeErrorTranslator } from '@css-xp/base';

export const translateErrorMessage: StripeErrorTranslator = (err) => {
  if (err.error?.type === 'stripe-error' && err.error.stripeError?.code === 'expired_card') {
    return <div data-testid="card-expired">This card is expired. Try again by adding a valid card.</div>;
  }
  return;
};
